import { useState } from "react";
import styled from "styled-components";
import { SettingTabPanel } from "../components/tab-panel/SettingTabPanel";
import { GeneralTab } from "../components/tab/GeneralTab";
import {useAppSelector} from "../app/hooks";
import {profileState} from "../app/reducers/profile-slice";
import {isSuperuser} from "../utils/user/check-user-type";

export enum SettingTab {
  Notification = "앱 알림",
  Version = "앱 버전",
  Information = "정보",
}

const tabMap: { [key: string]: SettingTab } = {
  [SettingTab.Notification]: SettingTab.Notification,
};

export const SettingView = () => {
  const { profile } = useAppSelector(profileState);

  if (isSuperuser(profile)) {
    tabMap[SettingTab.Version] = SettingTab.Version;
    // tabMap[SettingTab.Information] = SettingTab.Information;
  }

  const [tab, setTab] = useState({
    index: 0,
    key: Object.keys(tabMap)[0],
  });

  const handleClickTab = (key: string, index: number) => {
    setTab({
      key,
      index,
    });
  };

  return (
    <SettingViewViewContainer>
      <SettingViewTitle>
        <GeneralTab tabMap={tabMap} tab={tab} onClickTab={handleClickTab} />
      </SettingViewTitle>
      <SettingViewContent>
        <SettingTabPanel tabValue={tabMap[tab.key]} />
      </SettingViewContent>
    </SettingViewViewContainer>
  );
};

const SettingViewViewContainer = styled.div`
  width: 100%;
`;

const SettingViewTitle = styled.div`
  display: flex;
  padding: 1.5rem 4rem;
`;

const SettingViewContent = styled.div`
  width: 61%;
  margin: 0 auto;
`;
